import * as React from 'react';
import ReactHTMLParser from 'react-html-parser';

export const nl2Br = (str: string, splitBy = '\r\n', showIndex = false, styles = {}) => {
  return str?.split(splitBy).map((item, i) => {
    const style = {
      ...(item && {
        margin: '3px 0px',
      }),
      ...(!item && {
        margin: '13px 0px',
      }),
      ...styles,
    };
    return (
      <div key={i} style={style}>
        {showIndex && <span style={{ marginRight: '6px' }}>{i + 1}.</span>}<span>{ReactHTMLParser(item)}</span>
      </div>
    );
  });
};
